var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgroundIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 19.5C8.8181 19.5 7.64778 19.2672 6.55585 18.8149C5.46392 18.3626 4.47177 17.6997 3.63604 16.864C2.80031 16.0282 2.13738 15.0361 1.68508 13.9442C1.23279 12.8522 1 11.6819 1 10.5C1 9.3181 1.23279 8.14778 1.68508 7.05585C2.13738 5.96392 2.80031 4.97177 3.63604 4.13604C4.47177 3.30031 5.46392 2.63738 6.55585 2.18508C7.64778 1.73279 8.8181 1.5 10 1.5C12.3869 1.5 14.6761 2.34285 16.364 3.84315C18.0518 5.34344 19 7.37827 19 9.5C19 10.5609 18.5259 11.5783 17.682 12.3284C16.8381 13.0786 15.6935 13.5 14.5 13.5H12C11.5539 13.4928 11.1181 13.635 10.7621 13.904C10.4061 14.173 10.1503 14.5533 10.0353 14.9844C9.92034 15.4155 9.95284 15.8727 10.1276 16.2833C10.3025 16.6938 10.6095 17.0341 11 17.25C11.1997 17.4342 11.3366 17.6764 11.3915 17.9425C11.4465 18.2085 11.4167 18.4851 11.3064 18.7334C11.196 18.9816 11.0107 19.1891 10.7764 19.3266C10.5421 19.4641 10.2705 19.5247 10 19.5Z",
    stroke: "inherit",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 9.5C5.77614 9.5 6 9.27614 6 9C6 8.72386 5.77614 8.5 5.5 8.5C5.22386 8.5 5 8.72386 5 9C5 9.27614 5.22386 9.5 5.5 9.5Z",
    stroke: "#inherit",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.5C10.2761 6.5 10.5 6.27614 10.5 6C10.5 5.72386 10.2761 5.5 10 5.5C9.72386 5.5 9.5 5.72386 9.5 6C9.5 6.27614 9.72386 6.5 10 6.5Z",
    stroke: "#inherit",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 9.5C14.7761 9.5 15 9.27614 15 9C15 8.72386 14.7761 8.5 14.5 8.5C14.2239 8.5 14 8.72386 14 9C14 9.27614 14.2239 9.5 14.5 9.5Z",
    stroke: "#inherit",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundIcon);
export default __webpack_public_path__ + "static/media/background-icon.6dade15d.svg";
export { ForwardRef as ReactComponent };